import {Button} from 'platform/components';
import {HStack} from 'platform/foundation';

import {useNavigate} from 'shared/web';

import {MessageContextLink} from '../types/MessageContextLink';
import {getMessageContextLinkLabel} from '../utils/getMessageContextLinkLabel';

interface ThreadContextLinksProps {
  links: MessageContextLink[];
}

export function ThreadContextLinks(props: ThreadContextLinksProps) {
  const navigate = useNavigate();

  return (
    <HStack spacing={2} wrap>
      {props.links.map((link) => (
        <Button
          key={`${link.resourceId}-${link.recordId}`}
          variant="primary"
          size="small"
          leftIcon="action/launch"
          title={link.label ?? getMessageContextLinkLabel(link.resourceId)}
          onClick={() => navigate(link.path)}
          data-testid={`communicationThread-contextLink-${link.resourceId}`}
        />
      ))}
    </HStack>
  );
}
